import {Component, OnInit, ViewChild} from '@angular/core';
import { NavController, NavParams, Loading, LoadingController, ViewController, Events, Nav, App,
  ToastController, AlertController, Platform } from 'ionic-angular';
import {StorageService} from "../../providers/storage";
import {GetNewsService} from "../../providers/get-news-service";
import {FeedPage} from "../feed/feed";
import {MenuProvider} from "../../providers/menu";
import {NewsService} from "../../providers/news-service";
import {SocialService} from "../../providers/social-service";
import {ConfigService} from "../../providers/config-service";

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage implements OnInit {

  public appVersion = '2.2.47';
  public logo = 'logo_DS.png';
  //@ViewChild(Nav) nav: Nav;
  public showPassword = false;
  public server1: {
    host: string,
    username: string,
    password: string,
    ssl: boolean
  };
  public server2: {
    host: string,
    username: string,
    password: string,
    ssl: boolean
  };

  private displayServer = 1;
  private loading: Loading;
  
  constructor(
    //public navCtrl: NavController,
    //public navParams: NavParams,
    private stg: StorageService,
    private getNewsService: GetNewsService,
    private loadingCtrl: LoadingController,
    //public viewCtrl: ViewController,
    private menuProvider: MenuProvider,
    private events: Events,
    private app: App,
    private newsSvc: NewsService,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    //private platform: Platform,
    private socialSvc: SocialService,
    public cfg: ConfigService
  ) {
    // Load login form data from storage
    this.loadLoginFormData();
    this.displayServer = parseInt(stg.get('currentServer'));

    // If autologin is on, perform the automatic login
    const autologin = this.stg.get('autologin');
    if (autologin === 'true') {
      this.loginDo(this.server1, this.server2);
    }

    // TODO check how to get the version number
    /* cordova.getAppVersion().getVersionNumber()
      .then((versionNumber) => {
        console.log(versionNumber);
        this.appVersion = versionNumber;
      }); */
  }

  private loadLoginFormData() {
    let hostname1;
    let hostname2;

    if (this.cfg.forceServer1Hostname) {
      hostname1 = this.cfg.server1Hostname;
    } else {
      hostname1 = this.stg.get('hostname1');
    }

    if (this.cfg.forceServer2Hostname) {
      hostname2 = this.cfg.server2Hostname;
    } else {
      hostname2 = this.stg.get('hostname2');
    }

    this.server1 = {
      host: hostname1,
      username: this.stg.get('username1'),
      password: this.stg.get('password1'),
      ssl: this.stg.get('ssl1') === 'true'
    };

    this.server2 = {
      host: hostname2,
      username: this.stg.get('username2'),
      password: this.stg.get('password2'),
      ssl: this.stg.get('ssl2') === 'true'
    };
  }

  ngOnInit() {}

  ionViewDidLoad() {
    // Handle lost authentication
    this.events.subscribe('authLost', () => {
        let nav = this.app.getActiveNavs()[0];
        nav.setRoot(LoginPage);
      });
  }

  public showServer(serverId: number) {
    return this.displayServer === serverId;
  }

  public switchToServer(serverId: number) {
    this.displayServer = serverId;
  }

  private saveLoginData() {
    // TODO fix this for non-strings
    this.stg.set('currentServer', this.displayServer);
    if (this.cfg.forceServer1Hostname) {
      this.stg.set('hostname1', this.cfg.server1Hostname);
    } else {
      this.stg.set('hostname1', this.server1.host);
    }
    this.stg.set('username1', this.server1.username);
    this.stg.set('password1', this.server1.password);
    if (this.cfg.forceServer2Hostname) {
      this.stg.set('hostname2', this.cfg.server2Hostname);
    } else {
      this.stg.set('hostname2', this.server2.host);
    }
    this.stg.set('username2', this.server2.username);
    this.stg.set('password2', this.server2.password);

    if (this.cfg.forceServer1Protocol) {
      this.stg.set('ssl1', this.cfg.server1Protocol());
    } else {
      this.stg.set('ssl1', this.server1.ssl);
    }

    if (this.cfg.forceServer2Protocol) {
      this.stg.set('ssl2', this.cfg.server2Protocol());
    } else {
      this.stg.set('ssl2', this.server2.ssl);
    }
  }

  public loginDo(server1, server2, force = false) {
    // Initialize and present loading indicator
    this.loading = this.loadingCtrl.create({
      content: 'Attendere...',
      dismissOnPageChange: true
    });
    this.loading.present();

    // Save login data
    this.saveLoginData();
    //this.getNewsService.generateServerUrl();

    // effettuare il login
    this.getNewsService.login(force).subscribe(
      (data: any) => {
        if (data.status === 1) {
          let toast = this.toastCtrl.create({
            message: 'Accesso consentito',
            duration: 3000
          });
          // this.loading.dismiss();
          toast.present();
          // salvo la sessione
          this.stg.set('jsessionid', ';jsessionid=' + data.sessionId);
          this.stg.set('userId', data.userID);
          this.stg.set('servId', data.servID);
          this.stg.set('showKeywords', data.showKeywords); //settings
          this.stg.set('foreAlarm', data.foreAlarm);//settings
          this.stg.set('textSize', data.textSize);//settings
          this.stg.set('titleSize', data.titleSize);//settings
          this.stg.set('caseSensitiveSearch', data.caseSensitiveSearch);
          this.stg.set('pushOnDemand', data.pushOnDemand);
          this.stg.set('autologin', true);
          this.events.publish('login:ok');
          this.getNewsService.openNewWindow().subscribe(
            (dataa) => {
              // carico il menù
              this.getNewsService.getMenu().subscribe(
                (data) => {
                  // this.storageService.set('menu', data.menu);
                  this.menuProvider.menu = data.menu;
                  this.loading.dismiss();
                  // this.navCtrl.push(FeedPage);
                  // this.navCtrl.push(FeedPage);
                  // login effettuato correttamente, vado al feed
                  this.newsSvc.initializeLogos();
                  this.socialSvc.login(this.stg.get('userId'));
                  this.openPage(data);
                },
                (err) => {
                  // console.log('err');
                  this.loading.dismiss();
                }
              )
            }
          )
        } else if (data.status === 0) {
          if (data.errorCode === 14 && data.message === 'force_connect') {
            this.loading.dismiss();
            let confirm = this.alertCtrl.create({
              title: 'Attenzione!',
              message: 'Risulti già essere collegato da un\'altra postazione. Se confermi il collegamento l\'altra postazione potrebbe venire disconnessa',
              buttons: [
                {
                  text: 'Annulla',
                  handler: () => {
                    // console.log('Disagree clicked');
                    let nav = this.app.getActiveNavs()[0];
                    this.stg.set('autologin', false);
                    nav.setRoot(LoginPage);
                  }
                },
                {
                  text: 'Conferma',
                  handler: () => {
                    this.loginDo(server1, server2, true);
                  }
                }
              ]
            });
            confirm.present();
          } else {
            console.log(data);
            const toast = this.toastCtrl.create({
              message: 'Dati di accesso non corretti',
              duration: 3000
            });
            this.loading.dismiss();
            toast.present();
          }
// si è verificato un errore
// login non effettuato, mostro l'errore e lascio l'utente in questa schermata
// se il login è fallito valutare

// 1- credenziali errate

// 2- server non raggiungibile

// 3- account in uso --> modale
        }
      },
      (err) => {
        const toast = this.toastCtrl.create({
          message: 'Dati di accesso non corretti',
          duration: 3000
        });
        this.loading.dismiss();
        toast.present();
      }
    )
    ;


  }


  openPage(data) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    let nav = this.app.getActiveNavs()[0];
    let menu = data.menu.children[0];
    // console.log(menu);
    //console.log('OPEN MAIN PAGE')
    nav.setRoot(FeedPage, {fromMenu: menu.name})
      // .catch(err => console.log(err));
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts